/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExternalCsmsConfigDto } from './ExternalCsmsConfigDto';
import {
    ExternalCsmsConfigDtoFromJSON,
    ExternalCsmsConfigDtoFromJSONTyped,
    ExternalCsmsConfigDtoToJSON,
    ExternalCsmsConfigDtoToJSONTyped,
} from './ExternalCsmsConfigDto';

/**
 * 
 * @export
 * @interface UpdateOrganizationRequestDto
 */
export interface UpdateOrganizationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequestDto
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrganizationRequestDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequestDto
     */
    organizationType: UpdateOrganizationRequestDtoOrganizationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequestDto
     */
    mainLanguage: UpdateOrganizationRequestDtoMainLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequestDto
     */
    parentId: string | null;
    /**
     * External CSMS aggregate (endpoints + charger auth). Pass null to clear CSMS configuration. configVersion on request is ignored; server increments Organization.csmsConfigVersion on CSMS-mutating saves.
     * @type {ExternalCsmsConfigDto}
     * @memberof UpdateOrganizationRequestDto
     */
    externalCsmsConfig?: ExternalCsmsConfigDto | null;
}


/**
 * @export
 */
export const UpdateOrganizationRequestDtoOrganizationTypeEnum = {
    Operator: 'Operator',
    Manufacturer: 'Manufacturer',
    Landlord: 'Landlord',
    Oem: 'OEM'
} as const;
export type UpdateOrganizationRequestDtoOrganizationTypeEnum = typeof UpdateOrganizationRequestDtoOrganizationTypeEnum[keyof typeof UpdateOrganizationRequestDtoOrganizationTypeEnum];

/**
 * @export
 */
export const UpdateOrganizationRequestDtoMainLanguageEnum = {
    En: 'en',
    Fr: 'fr',
    De: 'de'
} as const;
export type UpdateOrganizationRequestDtoMainLanguageEnum = typeof UpdateOrganizationRequestDtoMainLanguageEnum[keyof typeof UpdateOrganizationRequestDtoMainLanguageEnum];


/**
 * Check if a given object implements the UpdateOrganizationRequestDto interface.
 */
export function instanceOfUpdateOrganizationRequestDto(value: object): value is UpdateOrganizationRequestDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('organizationType' in value) || value['organizationType'] === undefined) return false;
    if (!('mainLanguage' in value) || value['mainLanguage'] === undefined) return false;
    if (!('parentId' in value) || value['parentId'] === undefined) return false;
    return true;
}

export function UpdateOrganizationRequestDtoFromJSON(json: any): UpdateOrganizationRequestDto {
    return UpdateOrganizationRequestDtoFromJSONTyped(json, false);
}

export function UpdateOrganizationRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOrganizationRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'active': json['active'],
        'organizationType': json['organizationType'],
        'mainLanguage': json['mainLanguage'],
        'parentId': json['parentId'],
        'externalCsmsConfig': json['externalCsmsConfig'] == null ? undefined : ExternalCsmsConfigDtoFromJSON(json['externalCsmsConfig']),
    };
}

export function UpdateOrganizationRequestDtoToJSON(json: any): UpdateOrganizationRequestDto {
    return UpdateOrganizationRequestDtoToJSONTyped(json, false);
}

export function UpdateOrganizationRequestDtoToJSONTyped(value?: UpdateOrganizationRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'active': value['active'],
        'organizationType': value['organizationType'],
        'mainLanguage': value['mainLanguage'],
        'parentId': value['parentId'],
        'externalCsmsConfig': ExternalCsmsConfigDtoToJSON(value['externalCsmsConfig']),
    };
}

